<template>
  <div id="areastaff">
    <!-- {{PlugJson}} -->
  </div>
</template>

<script>
export default {
  name: "areastaff",
  props: {
    PlugJson: Object
  }
};
</script>

<style scoped>
</style>